export default __webpack_public_path__ + "static/media/trr-food-handheld-crispychicken.331f15af.png";